import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import axios from 'axios'
import Cookies from 'js-cookie'
import { FaSyncAlt } from 'react-icons/fa'
import { useNavigate, useParams } from 'react-router-dom'
import { Typeahead } from 'react-bootstrap-typeahead'
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table'
import { useAuth } from './AuthContext'

export default function DischargedStdAttendance() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth >= 992 ? '300px' : '0px',
  )
  const [openTable, setOpenTable] = useState(false)
const institute_id = Cookies.get('institute_id')


  const { student_id, course_id, class_id } = useParams()
  console.log(
    'STUDENT ID:',
    student_id,
    'COURSE ID: ',
    course_id,
    'CLASS_ID:',
    class_id,
  )
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [selectedData, setSelectedData] = useState([])
  const [allTeachers, setAllTeachers] = useState([])
  const [attendanceData, setAttendanceData] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState('')
  const [selectedClassId, setSelectedClassId] = useState('')
  const [admissionNo, setAdmissionNo] = useState('')
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    if (allStudents?.length > 0 && student_id && course_id && class_id) {
      console.log('✅ useEffect triggered with params:')
      console.log('All Students:', allStudents)
      console.log('student_id:', student_id)
      console.log('course_id:', course_id)
      console.log('class_id:', class_id)

      const student = allStudents.find((s) => s.id == Number(student_id))
      console.log('Found student:', student)

      if (student) {
        setSelectedStudent(student)
        setSelectedCourseId(student.course_id)
        setSelectedClassId(student.class_id)

        // Set course and load classes
        ApiEndpoints.getAllClassesByCourseId(student.course_id).then((res) => {
          console.log('Classes fetched for course:', res.data.data)
          setClasses(res.data.data || [])
        })

        // Set class and load attendance
        ApiEndpoints.getAllAttendance({
          class_id: student.class_id,
          student_id: student.id,
        }).then((res) => {
          console.log('Attendance data fetched:', res.data.attendance)

          const filteredAttendance = (res.data.attendance || []).filter(
            (entry) => entry.student_id === student.id,
          )

          console.log('✅ Filtered attendance for student:', filteredAttendance)

          setAttendanceData(filteredAttendance)
          setSelectedData(filteredAttendance)
          setOpenTable(true)
        })

        // Set filtered students of that class
        const filtered = allStudents.filter(
          (s) => s.course_id === student.course_id,
        )
        console.log('Filtered students by course:', filtered)
        setFilteredStudents(filtered)
      } else {
        console.warn('No matching student found for ID:', student_id)
      }
    }
  }, [allStudents, student_id, course_id, class_id])

  useEffect(() => {
    if (fromDate && toDate) {
      const filtered = attendanceData.filter((item) => {
        const itemDate = new Date(item.date)
        return itemDate >= fromDate && itemDate <= toDate
      })
      setSelectedData(filtered)
    } else {
      setSelectedData(attendanceData)
    }
  }, [fromDate, toDate, attendanceData])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)
  }, [])

  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')

    let token = null
    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (error) {
        console.error('Failed to parse user cookie', error)
      }
    }
    const fetchFilteredData = async () => {
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': institueId || institute_id,
        }

        const response = await axios.get(
          BASE_URL+'/students/inactive',
          { headers },
        )
        console.log('Response of all students:', response.data)
        setAllStudents(response.data.students)
      } catch (error) {
        console.error(error.response?.data?.message || 'Something wents wrong.')
      }
    }
    fetchFilteredData()
  }, [])
  const handleCourseChange = async (e) => {
    const courseId = Number(e.target.value)
    setSelectedCourseId(courseId)

    // Reset dependent data
    setClasses([])
    setFilteredStudents([])
    setSelectedStudent(null)

    if (courseId) {
      try {
        const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
        const classList = res.data.data || []
        setClasses(classList)

        // Filter students for this course
        const filtered = allStudents.filter((s) => s.course_id === courseId)
        setFilteredStudents(filtered)
      } catch (error) {
        toast.error('Error fetching classes or students.')
      }
    }
  }

  const handleRefresh = async () => {
    // Reset selected student, class, and attendance data
    setSelectedStudent(null)
    setSelectedClassId('')
    setSelectedCourseId('')
    setFilteredStudents([])
    setSelectedData([])
    setOpenTable(false)
    setFromDate(null)
    setToDate(null)
  }

  const handleClassChange = async (e) => {
    const classId = e.target.value
    setSelectedClassId(classId)
    setSelectedStudent(null)

    console.log('Selected Class ID:', classId)

    try {
      const payload = { class_id: parseInt(classId) }
      console.log('Fetching attendance with payload:', payload)

      const res = await ApiEndpoints.getAllAttendance(payload)
      setAttendanceData(res.data.attendance) // ✅ store full
      console.log('Attendance by Class:', res.data.attendance)
      setSelectedData(res.data.attendance)
    } catch (error) {
      console.error(
        'Error fetching attendance by class:',
        error.response?.data?.message,
      )
    }

    // Filter students by class
    const filtered = allStudents.filter(
      (student) => student.class_id === Number(classId),
    )
    setFilteredStudents(filtered)
    setOpenTable(true)
  }
  const handleStudentChange = async (e) => {
    const studentId = Number(e.target.value)
    const student = filteredStudents.find((s) => s.id === studentId)

    if (student) {
      setSelectedStudent(student)
      setSelectedCourseId(student.course_id) // sync course dropdown
      // setSelectedClassId(student.class_id)
      // Fetch classes for course if not already fetched
      if (!classes.length) {
        const res = await ApiEndpoints.getAllClassesByCourseId(
          student.course_id,
        )
        setClasses(res.data.data || [])
      }

      setOpenTable(true)

      try {
        const res = await ApiEndpoints.getAllAttendance({
          class_id: student.class_id,
          student_id: student.id,
        })
        const filteredAttendance = (res.data.attendance || []).filter(
          (entry) => entry.student_id === student.id,
        )
        setAttendanceData(filteredAttendance)
        setSelectedData(filteredAttendance)
      } catch (error) {
        console.error(
          'Error fetching student attendance:',
          error.response?.data?.message,
        )
      }
    }
  }

  useEffect(() => {
    if (fromDate && toDate) {
      const filtered = attendanceData.filter((item) => {
        const itemDate = new Date(item.date)
        return itemDate >= fromDate && itemDate <= toDate
      })
      setSelectedData(filtered)
    } else {
      setSelectedData(attendanceData)
    }
  }, [fromDate, toDate, attendanceData])

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth >= 992 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0 "
        style={{ marginTop: window.innerWidth < 992 ? '55px' : '-12px' }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">
            {selectedStudent ? (
              <>
                View{' '}
                <span className="text-warning">
                  {selectedStudent.name.charAt(0).toUpperCase() +
                    selectedStudent.name.slice(1).toLowerCase()}
                </span>
                's Attendance
              </>
            ) : (
              'View Student Attendance'
            )}
          </h2>
        </div>
      </div>

      <Row className="g-2 align-items-end d-flex mt-3 flex-wrap">
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Course</Form.Label>
            {/* <Form.Select value={selectedCourseId} onChange={handleCourseChange}>
              <option>Select Course</option>
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="course-select"
              labelKey="name"
              onChange={(selected) => {
                const course = selected[0]
                if (course) {
                  handleCourseChange({ target: { value: course.id } })
                } else {
                  handleCourseChange({ target: { value: '' } })
                }
              }}
              options={courses}
              placeholder="Select Course"
              selected={courses.filter(
                (cs) => cs.id === Number(selectedCourseId),
              )}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Class</Form.Label>
            {/* <Form.Select value={selectedClassId} onChange={handleClassChange}>
              <option>Select Class</option>
              {classes.map((cls) => (
                <option key={cls.id} value={cls.id}>
                  {cls.class_name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="class-select"
              labelKey="class_name"
              onChange={(selected) => {
                const cls = selected[0]
                if (cls) {
                  handleClassChange({ target: { value: cls.id } })
                } else {
                  handleClassChange({ target: { value: '' } })
                }
              }}
              options={classes}
              placeholder="Select Class"
              selected={classes.filter(
                (cs) => cs.id === Number(selectedClassId),
              )}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="text-start fw-bold mb-0">
            <Form.Label>Select Student</Form.Label>
            {/* <Form.Select
              value={selectedStudent?.id}
              onChange={handleStudentChange}
            >
              <option>Select Student</option>

              {filteredStudents.map((student) => (
                <option key={student.id} value={student.id}>
                  {student.name}
                </option>
              ))}
            </Form.Select> */}
            <Typeahead
              id="student-select"
              labelKey={(option) =>
                `${option.name} - ${option.admission_number}`
              }
              onChange={(selected) => {
                const student = selected[0]
                if (student) {
                  // Simulate event for your existing handler
                  handleStudentChange({ target: { value: student.id } })
                } else {
                  // Clear selection
                  setSelectedStudent(null)
                }
              }}
              onInputChange={(text) => {
                // Optional: clear selected student when user types
                if (text === '') {
                  setSelectedStudent(null)
                }
              }}
              options={filteredStudents}
              placeholder="Select Student"
              selected={
                selectedStudent
                  ? filteredStudents.filter((s) => s.id === selectedStudent.id)
                  : []
              }
              // clearButton
            />
          </Form.Group>
        </Col>
        <Col className="d-flex justify-content-md-end justify-content-start">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>
      {openTable && (
        <>
          <Row className="mb-3 d-flex justify-content-start">
            <Col className="text-start fw-bold mt-3">
              <label>Start Date</label>
              <input
                type="date"
                value={
                  fromDate instanceof Date && !isNaN(fromDate)
                    ? fromDate.toISOString().split('T')[0]
                    : ''
                }
                onChange={(e) =>
                  setFromDate(e.target.value ? new Date(e.target.value) : null)
                }
                className="form-control form-control"
              />
            </Col>
            <Col className="text-start fw-bold mt-3">
              <label>End Date</label>
              <input
                type="date"
                value={
                  toDate instanceof Date && !isNaN(toDate)
                    ? toDate.toISOString().split('T')[0]
                    : ''
                }
                onChange={(e) =>
                  setToDate(e.target.value ? new Date(e.target.value) : null)
                }
                className="form-control form-control"
              />
            </Col>
          </Row>

          <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
            <Thead className="bg-dark text-white">
              <Tr>
                <Th>Admission Number</Th>
                <Th>Student Name</Th>
                {/* <Th>Class Name</Th> */}
                <Th>Date</Th>
                <Th>Status</Th>
                <Th>Remarks</Th>
                {/* <Th>Teacher Name</Th> */}
              </Tr>
            </Thead>
            <Tbody>
              {selectedData && selectedData.length > 0 ? (
                selectedData.map((att, index) => {
                  const rowStyle = {
                    backgroundColor:
                      att.status === 'present'
                        ? 'rgba(0, 128, 0, 0.1)' // light green
                        : att.status === 'absent'
                        ? 'rgba(255, 0, 0, 0.1)' // light red
                        : 'transparent',
                  }

                  const statusStyle = {
                    ...rowStyle,
                    fontWeight: 'bold',
                    letterSpacing: '1px',
                    color:
                      att.status === 'present'
                        ? 'green'
                        : att.status === 'absent'
                        ? 'red'
                        : 'black',
                  }
                  return (
                    <Tr key={index} className="align-middle">
                      <Td style={rowStyle}>
                        {allStudents.find(
                          (stu) => stu.name === att.student_name,
                        )?.admission_number || 'N/A'}
                      </Td>

                      <Td style={rowStyle}>{att.student_name || 'N/A'}</Td>
                      <Td style={rowStyle}>
                        {att.date
                          ? new Date(att.date).toLocaleDateString('en-GB', {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            })
                          : 'N/A'}
                      </Td>
                      <Td style={statusStyle}>
                        {att.status
                          ? att.status.charAt(0).toUpperCase() +
                            att.status.slice(1)
                          : 'N/A'}
                      </Td>
                      <Td style={rowStyle}>{att.remarks || '—'}</Td>
                    </Tr>
                  )
                })
              ) : (
                <Tr>
                  <Td colSpan="4" className="text-center text-muted">
                    No attendance data found.
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </>
      )}
    </div>
  )
}
